var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarketconnectSelectapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 88,
    viewBox: "0 0 182 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_561_4539)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 182,
    height: 88,
    fill: "#FFE5E5"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_561_4539)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.9033,
    y: 17.9004,
    width: 114,
    height: 79,
    rx: 4,
    fill: "url(#paint0_linear_561_4539)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.9033,
    y: 16.9004,
    width: 116,
    height: 81,
    rx: 5,
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 106.903,
    y: 50.9004,
    width: 10,
    height: 41,
    rx: 2,
    fill: "#FF8049"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.9033,
    y: 70.9004,
    width: 10,
    height: 21,
    rx: 2,
    fill: "#FF8049"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.903,
    y: 45.9004,
    width: 10,
    height: 46,
    rx: 2,
    fill: "#FF8049"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.903,
    y: 56.9004,
    width: 10,
    height: 35,
    rx: 2,
    fill: "#FF8049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9033 74.9004L60.0347 82.769C59.6387 83.165 59.4407 83.363 59.2123 83.4372C59.0115 83.5025 58.7951 83.5025 58.5943 83.4372C58.366 83.363 58.168 83.165 57.7719 82.769L55.0347 80.0318C54.6387 79.6357 54.4407 79.4377 54.2123 79.3635C54.0115 79.2983 53.7951 79.2983 53.5943 79.3635C53.366 79.4377 53.168 79.6357 52.7719 80.0318L47.9033 84.9004M67.9033 74.9004H60.9033M67.9033 74.9004V81.9004",
    stroke: "#FF4A00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.403,
    cy: 25.4004,
    r: 1.5,
    fill: "#FF8049"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137.403,
    cy: 25.4004,
    r: 1.5,
    fill: "#FF8049"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142.403,
    cy: 25.4004,
    r: 1.5,
    fill: "#FF8049"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9033 25.9004C58.9033 24.7958 59.7988 23.9004 60.9033 23.9004H119.903C121.008 23.9004 121.903 24.7958 121.903 25.9004V26.9004C121.903 28.005 121.008 28.9004 119.903 28.9004H60.9033C59.7988 28.9004 58.9033 28.005 58.9033 26.9004V25.9004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9033 33.9004C58.9033 32.7958 59.7988 31.9004 60.9033 31.9004H93.9033C95.0079 31.9004 95.9033 32.7958 95.9033 33.9004V34.9004C95.9033 36.005 95.0079 36.9004 93.9033 36.9004H60.9033C59.7988 36.9004 58.9033 36.005 58.9033 34.9004V33.9004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9033 41.9004C58.9033 40.7958 59.7988 39.9004 60.9033 39.9004H101.903C103.008 39.9004 103.903 40.7958 103.903 41.9004V42.9004C103.903 44.005 103.008 44.9004 101.903 44.9004H60.9033C59.7988 44.9004 58.9033 44.005 58.9033 42.9004V41.9004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3631 50.2395C30.6627 46.6024 29.0043 42.2983 28.5661 37.7896C28.1279 33.2809 28.9264 28.738 30.8759 24.649L53.3796 35.3779L33.3631 50.2395Z",
    fill: "#FE4A01"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_561_4539)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-1_561_4539",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1006 26.2653C32.1169 21.0812 35.8089 16.7203 40.5893 13.8765C45.3697 11.0326 50.9638 9.86906 56.4817 10.571C61.9996 11.273 67.1242 13.8001 71.0403 17.7503C74.9564 21.7005 77.439 26.8468 78.093 32.3706C78.7471 37.8944 77.5351 43.4782 74.6498 48.2337C71.7646 52.9893 67.3719 56.6433 62.1705 58.6145C56.9692 60.5857 51.258 60.7609 45.9456 59.1121C40.6333 57.4633 36.0249 54.0852 32.8537 49.5154L53.3356 35.3021L30.1006 26.2653Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.1006 26.2653C32.1169 21.0812 35.8089 16.7203 40.5893 13.8765C45.3697 11.0326 50.9638 9.86906 56.4817 10.571C61.9996 11.273 67.1242 13.8001 71.0403 17.7503C74.9564 21.7005 77.439 26.8468 78.093 32.3706C78.7471 37.8944 77.5351 43.4782 74.6498 48.2337C71.7646 52.9893 67.3719 56.6433 62.1705 58.6145C56.9692 60.5857 51.258 60.7609 45.9456 59.1121C40.6333 57.4633 36.0249 54.0852 32.8537 49.5154L53.3356 35.3021L30.1006 26.2653Z",
    fill: "#FF8049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1006 26.2653C32.1169 21.0812 35.8089 16.7203 40.5893 13.8765C45.3697 11.0326 50.9638 9.86906 56.4817 10.571C61.9996 11.273 67.1242 13.8001 71.0403 17.7503C74.9564 21.7005 77.439 26.8468 78.093 32.3706C78.7471 37.8944 77.5351 43.4782 74.6498 48.2337C71.7646 52.9893 67.3719 56.6433 62.1705 58.6145C56.9692 60.5857 51.258 60.7609 45.9456 59.1121C40.6333 57.4633 36.0249 54.0852 32.8537 49.5154L53.3356 35.3021L30.1006 26.2653Z",
    stroke: "white",
    strokeWidth: 2,
    mask: "url(#path-15-inside-1_561_4539)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_561_4539",
    x: 22.9033,
    y: 13.9004,
    width: 142,
    height: 107,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_561_4539"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_561_4539"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_561_4539"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_561_4539",
    result: "effect2_dropShadow_561_4539"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_561_4539",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_561_4539",
    x: 18.1006,
    y: 8.37109,
    width: 72.165,
    height: 73.8613,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_561_4539"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_561_4539"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_561_4539"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_561_4539",
    result: "effect2_dropShadow_561_4539"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_561_4539",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_561_4539",
    x1: -105.597,
    y1: -86.0996,
    x2: 198.403,
    y2: 142.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDF7FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_561_4539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 182,
    height: 88,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketconnectSelectapp);
export default __webpack_public_path__ + "static/media/marketconnect-selectapp.55360b4783d4394e13650d37d573e90e.svg";
export { ForwardRef as ReactComponent };